import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';

import { useIsRouteSegment } from '@shared/hooks';
import { Popup } from '@shared/ui';

import cls from './InformationTitle.module.css';
import { useInformationTitle } from './useInformationTitle';
import { Icon } from '../../../../../../components/newUI/Icon/Icon';

interface InformationTitleProps {
    classes?: string;
}

export enum SecondModalMode {
    ARCHIVE = 'archiveProject',
    DELETE = 'deleteProject',
    UNARCHIVE = 'unArchiveProject',
}

export const InformationTitle = ({ classes }: InformationTitleProps) => {
    const {
        onEditInformation,
        is_archive,
        secondModalMode,
        openSecondModal,
        onClickIcon,
        onCansel,
        is_customer,
        can_show_financial_info,
        is_can_archive_project,
    } = useInformationTitle();

    const fromCrm = useIsRouteSegment('crm');

    const { t } = useTranslation();

    return (
        <>
            <Popup
                isOpen={openSecondModal}
                onHidePopup={onCansel}
                btnActionCb={secondModalMode.onClick}
                type="delete"
                deleteButtonText={secondModalMode.buttonText}
                cancelButtonText={t('InformationTitle.return.popup.cancel')}
                popupContentClassName={cls.secondModal}
                contentText=" "
            >
                <div>
                    <span>{secondModalMode.text}</span>
                </div>
            </Popup>

            <div className={classNames(cls.InformationTitle, [classes])}>
                <span className={cls.title}>{t('InformationTitle.return.title')}</span>
                {!is_customer && can_show_financial_info && (
                    <div className={cls.buttonList}>
                        <ReactTooltip
                            id="global-editInformation"
                            aria-haspopup="true"
                            effect="solid"
                            delayHide={200}
                            delayShow={200}
                            type="light"
                            className={cls.tooltip}
                        >
                            <p>{t('InformationTitle.return.editTooltip')}</p>
                        </ReactTooltip>
                        <button
                            data-tip
                            data-for="global-editInformation"
                            type="button"
                            className={cls.buttonInformation}
                            onClick={onEditInformation}
                        >
                            <Icon iconName="editInformationBlock" />
                        </button>
                        {is_archive ? (
                            <>
                                {is_can_archive_project && !fromCrm && (
                                    <>
                                        <ReactTooltip
                                            id="global-unArchiveInformationBlock"
                                            aria-haspopup="true"
                                            effect="solid"
                                            delayHide={200}
                                            delayShow={200}
                                            type="light"
                                            className={cls.tooltip}
                                        >
                                            <p>{t('InformationTitle.return.unArchiveTooltip')}</p>
                                        </ReactTooltip>
                                        <ReactTooltip
                                            id="global-deleteInformationBlock"
                                            aria-haspopup="true"
                                            effect="solid"
                                            delayHide={200}
                                            delayShow={200}
                                            type="light"
                                            className={cls.tooltip}
                                        >
                                            <p>{t('InformationTitle.return.deleteTooltip')}</p>
                                        </ReactTooltip>
                                        <button
                                            data-tip
                                            data-for="global-unArchiveInformationBlock"
                                            type="button"
                                            className={cls.buttonInformation}
                                            onClick={() => onClickIcon(SecondModalMode.UNARCHIVE)}
                                        >
                                            <Icon iconName="unArchiveInformationBlock" />
                                        </button>
                                        <button
                                            data-tip
                                            data-for="global-deleteInformationBlock"
                                            type="button"
                                            className={cls.buttonInformation}
                                            onClick={() => onClickIcon(SecondModalMode.DELETE)}
                                        >
                                            <Icon iconName="deleteInformationBlock" />
                                        </button>
                                    </>
                                )}
                            </>
                        ) : (
                            <>
                                {is_can_archive_project && !fromCrm && (
                                    <>
                                        <ReactTooltip
                                            id="global-archiveInformationBlock"
                                            aria-haspopup="true"
                                            effect="solid"
                                            delayHide={200}
                                            delayShow={200}
                                            type="light"
                                            className={cls.tooltip}
                                        >
                                            <p>{t('InformationTitle.return.archiveTooltip')}</p>
                                        </ReactTooltip>
                                        <button
                                            data-tip
                                            data-for="global-archiveInformationBlock"
                                            type="button"
                                            className={cls.buttonInformation}
                                            onClick={() => onClickIcon(SecondModalMode.ARCHIVE)}
                                        >
                                            <Icon iconName="archiveInformationBlock" />
                                        </button>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};
